'use client'

import React from 'react'
import { Autoplay } from 'swiper/modules'
import { Swiper } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/autoplay'

export interface IMSwiperProps {
	children: React.ReactNode
	spaceBetween?: number
	slidesPerView?: number
	autoplay?: boolean
	autoplayDelay?: number
	loop?: boolean
	className?: string
}

/**
 * MSwiper - Universal Swiper wrapper component
 * Simplified wrapper around Swiper for carousel functionality
 */
export const MSwiper: React.FC<IMSwiperProps> = ({
	children,
	spaceBetween = 16,
	slidesPerView = 1,
	autoplay = false,
	autoplayDelay = 2500,
	loop = false,
	className
}) => {
	return (
		<Swiper
			spaceBetween={spaceBetween}
			slidesPerView={slidesPerView}
			loop={loop}
			autoplay={
				autoplay
					? {
							delay: autoplayDelay,
							disableOnInteraction: false
						}
					: false
			}
			modules={[Autoplay]}
			className={className}
		>
			{children}
		</Swiper>
	)
}

MSwiper.displayName = 'MSwiper'

// Re-export SwiperSlide for convenience
export { SwiperSlide } from 'swiper/react'
